import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

const Analysis = ({ size = 72, ...props }) => (
  <Svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M46.456 21.094h-12.81l-.498-1.405c-2.01-5.673-7.394-6.672-7.836-6.93V0l2.53.514c9.146 1.856 16.251 8.942 18.1 18.05l.514 2.53Z"
      fill="#6AA9FF"
    />
    <Path
      d="M12.656 23.203c0-8.336 8.387-10.407 8.438-10.443V0l-2.53.514C7.819 2.695 0 12.142 0 23.204 0 29.6 2.602 35.4 6.804 39.601l7.891-1.914 1.054-7.03a10.513 10.513 0 0 1-3.093-7.455Z"
      fill="#FF641A"
    />
    <Path
      d="m45.652 25-.513 2.528C42.98 38.16 33.575 46.094 22.399 46.094c-6.396 0-12.197-2.602-16.399-6.804l8.945-8.945a10.514 10.514 0 0 0 7.455 3.093c8.534 0 10.272-8.198 10.443-8.438h12.809Z"
      fill="#FFE470"
    />
    <Path
      d="m46.456 25.312-.514 2.529C43.784 38.472 34.38 46.406 23.203 46.406V33.75c8.535 0 10.273-8.197 10.443-8.438h12.81Z"
      fill="#FFE470"
    />
    <Path d="M54.984 34.031h12.657v35.86H54.984V34.03Z" fill="#596379" />
    <Path d="M38.11 55.125h12.656V69.89H38.109V55.125Z" fill="#8691A8" />
    <Path d="M21.234 50.906h12.657v18.985H21.234V50.906Z" fill="#596379" />
    <Path d="M4.36 59.344h12.656V69.89H4.359V59.344Z" fill="#D1D9E9" />
    <Path d="M0 67.781h72V72H0V67.78Z" fill="#8691A8" />
    <Path d="M36 67.781h36V72H36V67.78Z" fill="#596379" />
  </Svg>
)

export default Analysis
